import { useEffect, useState } from "react";
import { useUpdateDocumentContentMutation } from "../../../../../../../features/authentication/teacherDocumentApiSlice";
import PropTypes from "prop-types";
import { Form, Button } from "react-bootstrap";
import Modal from "../../../../../../../components/Modal";
import CustomToast from "../../../../../../../components/Toast";
import RichTextBox from '../../../../../../../components/RichTextBox/index';

const UpdateDescriptionModal = ({ showModal, setShowModal, document, onUpdateDocumentContent }) => {
  const [updateDocumentContent, {isLoading: documentIsLoading}] = useUpdateDocumentContentMutation();
  const [documentContent, setDocumentContent] = useState(document?.document);

  useEffect(() =>{
    setDocumentContent(document?.document);
  },[showModal]);

  const handleUpdateDocumentContent = async (e) => {
    e.preventDefault();
    if (documentContent == document.document) {
      setShowModal(false);
      return;
    }

    const option = {
      documentId: document.documentId,
      content: documentContent
    };

    try {
      const result = await updateDocumentContent(option);
      if (result.error) {
        CustomToast(result.error.data.error, 'error');
      }
      else {
        CustomToast('Document Changes Saved Successfully.', 'success');
        onUpdateDocumentContent();
        setShowModal(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal
      isOpen={showModal}
      onClose={() => setShowModal(false)}
      titleName='Update Document'
      contentWidth='50%'>
      <Form className='d-flex flex-column' onSubmit={(e) => handleUpdateDocumentContent(e)}>

        <div className='mb-3'>Resource</div>
        <RichTextBox
          content={documentContent}
          setContent={setDocumentContent}
          disabled={documentIsLoading}
        />

        <div className='d-flex flex-row justify-content-end gap-2 mt-3'>
          <Button style={{ minWidth: '90px' }} variant='castleGray' onClick={() => setShowModal(false)}>Cancel</Button>
          <Button disabled={documentIsLoading} style={{ minWidth: '90px' }} variant='castleRed' type='submit'>{documentIsLoading ? 'Saving...' : 'Save'}</Button>
        </div>
      </Form>
    </Modal>
  );
};

UpdateDescriptionModal.propTypes = {
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,
  document: PropTypes.object,
  setId: PropTypes.number,
  onUpdateDescription: PropTypes.func
};

export default UpdateDescriptionModal;